import React from 'react';
import { Box, Typography } from '@mui/material';

function AnalysisPage() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>Analysis Center</Typography>
      <Typography variant="body1">AI analysis tools and reports coming soon...</Typography>
    </Box>
  );
}

export default AnalysisPage;
